<template>
  <SglImage
    :src="require('@/assets/images/index/bg-card.png')"
    :width="380"
    :height="598"
    class="sgl-aligncenter"
    @click="showShiJi"
  >
    <div
      style="
        width: calc(350 / 10.8 * var(--app-vw));
        height: calc(53 * var(--app-vw));
        margin-top: calc(2 * var(--app-vw));
        /* background: red; */
      "
      class="sgl-aligncenter"
    >
      <div
        style="
          background: linear-gradient(to bottom right, #fa7b5c, #00c5dd);
          border-radius: 5px;
        "
      >
        <SglImage :src="avatar" :width="350" :height="350">
          <SglImage
            :src="require('@/assets/images/index/card-star-l.png')"
            :width="73"
            :height="70"
            style="
              position: absolute;
              top: calc(2 * var(--app-vw));
              left: calc(2 * var(--app-vw));
            "
            @click.native.stop="vote"
            v-if="select"
          >
          </SglImage>
          <SglImage
            :src="require('@/assets/images/index/card-star.png')"
            :width="73"
            :height="70"
            style="
              position: absolute;
              top: calc(2 * var(--app-vw));
              left: calc(2 * var(--app-vw));
            "
            @click.native.stop="vote"
            v-else
          >
          </SglImage>
          <div
            :style="{
              position: 'absolute',
              bottom: 'calc(2 * var(--app-vw))',
              right: 'calc(2 * var(--app-vw))',
              color: '#fdf3a6',
              'background-color': '#ff863e',
              padding: 'calc(1 * var(--app-vw))',
              'border-radius': '1000px',
              'text-align': 'center',
              'font-size': '0.9rem',
            }"
          >
            {{ player.no < 10 ? "0" + player.no : player.no }}
          </div>
        </SglImage>
      </div>
      <div
        :style="{
          'text-align': 'center',
          width: '90%',
          'min-height': 'calc(8 * var(--app-vw))',
          height: 'calc(8 * var(--app-vw))',
          margin: '0.4rem 0',
        }"
        class="sgl-center"
      >
        <p
          :style="{
            'font-size': fontSize,
            'text-align': 'center',
            'font-weight': 'bold',
            width: 'fit-content',
            'max-width': '100%',
            margin: 'calc(0.5 * var(--app-vw)) 0',
          }"
        >
          {{ player.name }}
        </p>
      </div>
      <SglImage
        :src="require('@/assets/images/index/card-btnbg.png')"
        :width="269"
        :height="79"
        class="sgl-aligncenter"
      >
      </SglImage>
    </div>
  </SglImage>
</template>

<script>
export default {
  name: "SiguileCszx2025H5PlayerCard",
  props: {
    player: {
      type: Object,
      default: {},
    },
    select: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    avatar() {
      if (this.player && this.player.avatar) {
        return this.player.filePrefix + this.player.avatar;
      } else {
        return null;
      }
    },
    nameLine() {
      if (this.player && this.player.name) {
        if (this.player.name.length <= 8) {
          return 1;
        } else if (this.player.name.length <= 20) {
          return 2;
        }
        return 3;
      }
      return 1;
    },
    fontSize() {
      if (this.player && this.player.name) {
        if (this.player.name.length <= 8) {
          return "calc(3.3 * var(--app-vw))";
        } else if (this.player.name.length <= 16) {
          return "calc(3 * var(--app-vw))";
        }
        return "calc(2.8 * var(--app-vw))";
      }
      return "calc(3.3 * var(--app-vw))";
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    vote() {
      if (!this.player || !this.player.name) {
        return;
      }
      this.$emit("vote");
    },
    showShiJi() {
      if (!this.player || !this.player.name) {
        return;
      }
      this.$emit("showShiJi");
    },
  },
};
</script>

<style  scoped>
</style>


// WEBPACK FOOTER //
// src/components/PlayerCard.vue